module.exports = __webpack_public_path__ + "depart_right.svg?d0854d6d7eda2be1f041ff0aab91eb7e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/depart_right.svg
// module id = 159
// module chunks = 0